import { authorizedFetch } from '@/client'
import { Button, Container, Grid } from '@mui/joy'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import i18n from '@/i18n'
import { OpenInNew } from '@mui/icons-material'
import { HBox } from '@/components/HBox'
import { PlanCard } from '@/components/PlanCard'
import { useManager, useResource } from '@/hooks'
import { beginSubscribeToProduct } from '@/actions/aloader'
import { useNavigate } from 'react-router-dom'


export function BillingPage() {
    const manager = useManager()

    return (
        <Container>
            <BillingContainer managerId={manager?.id} managerType={manager?.type} />
        </Container>
    )
}

export function BillingContainer({
    managerId,
    managerType
}) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [subscribing, setSubscribing] = useState(false)

    const { data } = useResource({
        queryPath: [managerType, managerId, 'plans'],
        path: `/${managerType}/${managerId}/plans`
    })

    const products = data?.results ?? []

    const beginSubscribe = (productId) => {
        setSubscribing(true)
        beginSubscribeToProduct({ productId, managerType, managerId }).then(result => {
            if (result.url) {
                window.location.href = (result.url)
            } else {
                console.error('No URL returned from subscribe action')
            }
        }).catch(e => {
            console.error(e)
        })
    }

    const handleBillingSubmit = event => {
        event.preventDefault()
        setLoading(true)
        authorizedFetch('POST', `/${managerType}/${managerId}/billing`, {
            body: JSON.stringify({
                billing: true
            })
        }).then(result => {
            window.open(result.url, '_blank')
        }).catch(e => {
            console.error(e)
        }).finally(() => {
            setLoading(false)
        })
    }
    return (
        <div>
            <h1>Billing</h1>
            <form method="POST" onSubmit={handleBillingSubmit}>
                <p>All billing is handled by our payment provider, Stripe in their Customer Portal. Click the button below to go to the billing page.</p>
                <Button loading={loading} type="submit">{i18n.t('go-to-billing')}<OpenInNew /></Button>
            </form>
            <h3>{i18n.t('available-plans')}</h3>
            <Grid container spacing={2}> 
                {products.map(product => (
                    <Grid item xs={12} md={4}>
                        <PlanCard
                            subscribing={subscribing}
                            name={product.name}
                            price={product?.default_price?.amount}
                            description={product.description}
                            features={product.features}
                            subscription={product.subscription}
                            onSubscribeClick={() => {
                                beginSubscribe(product.id)
                            }}
                            onCancelClick={() => {
                                navigate(`subscription/${product.subscription.id}/cancel`)
                            }}
                        />
                    </Grid>
                ))} 
            </Grid>
        </div>
    )
}

export default BillingPage;